import { useEffect, useState } from 'react';
import { getFiscalProfile } from '../../../fiscal/infra-api';

/**
 * Determina si el formulario de producto debe mostrar el selector de tasa de IVA.
 * Solo aplica cuando el régimen fiscal de la sucursal es "responsable inscripto".
 */
export function useAllowIvaRate(branchId: string | null | undefined): boolean {
  const [allowIvaRate, setAllowIvaRate] = useState(false);

  useEffect(() => {
    if (!branchId) {
      setAllowIvaRate(false);
      return;
    }
    let cancelled = false;
    void getFiscalProfile(branchId)
      .then((profile) => {
        if (!cancelled) setAllowIvaRate(profile?.taxRegime === 'responsable_inscripto');
      })
      .catch(() => {
        if (!cancelled) setAllowIvaRate(false);
      });
    return () => {
      cancelled = true;
    };
  }, [branchId]);

  return allowIvaRate;
}
